import React from 'react';
const RadioNone = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-video-off"
        {...props}
    >
        <circle cx="12" cy="12" r="2"></circle>

    </svg>
);


export default RadioNone;





